var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInLove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "492.3px",
    height: "425.91px",
    viewBox: "0 0 492.3 425.91",
    enableBackground: "new 0 0 492.3 425.91",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDDFE3",
    d: "M46.02,75.81c-67.71,42.73-48.37,138.71,58.33,261.17c124.73,143.15,303.86,72.03,350.85-47.4 c48.4-123.02,38.43-259.05-45.27-276.04c-98.5-19.99-118.38,59.12-186.29,65.63C146.47,86.57,107.68,36.9,46.02,75.81z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#868B90",
    d: "M109.71,130.68c-48.49,28.66-34.63,93.04,41.77,175.17c89.31,96.02,217.58,48.31,251.23-31.79 c34.66-82.52,27.52-173.75-32.42-185.15c-70.53-13.41-84.77,39.66-133.39,44.02C181.64,137.89,153.86,104.58,109.71,130.68z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 345.0389,
    cy: 156.3335,
    r: 57.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEB3B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABFC3",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M109.71,130.68c-48.49,28.66-34.63,93.04,41.77,175.17c89.31,96.02,217.58,48.31,251.23-31.79 c34.66-82.52,27.52-173.75-32.42-185.15c-70.53-13.41-84.77,39.66-133.39,44.02C181.64,137.89,153.86,104.58,109.71,130.68z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 146.5007,
    cy: 169.5233,
    r: 41.8778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEB3B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A5ABAE",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M109.71,130.68c-48.49,28.66-34.63,93.04,41.77,175.17c89.31,96.02,217.58,48.31,251.23-31.79 c34.66-82.52,27.52-173.75-32.42-185.15c-70.53-13.41-84.77,39.66-133.39,44.02C181.64,137.89,153.86,104.58,109.71,130.68z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 252.4882,
    cy: 222.983,
    r: 185.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9BFC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7BBBF",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M109.71,130.68c-48.49,28.66-34.63,93.04,41.77,175.17c89.31,96.02,217.58,48.31,251.23-31.79 c34.66-82.52,27.52-173.75-32.42-185.15c-70.53-13.41-84.77,39.66-133.39,44.02C181.64,137.89,153.86,104.58,109.71,130.68z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 269.1328,
    cy: 227.9019,
    r: 173.3613,
    gradientTransform: "matrix(0.9796 -0.2012 0.1151 0.5606 -20.736 154.2766)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCE1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDE2E6",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M109.71,130.68c-48.49,28.66-34.63,93.04,41.77,175.17c89.31,96.02,217.58,48.31,251.23-31.79 c34.66-82.52,27.52-173.75-32.42-185.15c-70.53-13.41-84.77,39.66-133.39,44.02C181.64,137.89,153.86,104.58,109.71,130.68z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 268.2403,
    cy: 244.0086,
    r: 114.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFDEE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D3DFE6",
      stopOpacity: 0
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M109.71,130.68c-48.49,28.66-34.63,93.04,41.77,175.17c89.31,96.02,217.58,48.31,251.23-31.79 c34.66-82.52,27.52-173.75-32.42-185.15c-70.53-13.41-84.77,39.66-133.39,44.02C181.64,137.89,153.86,104.58,109.71,130.68z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M151.9,294.53c7.58,2.3,15.73,1.05,22.27-3.43c13.1-8.98,36.31-28.05,56.28-61 c29.75-49.09-3.36-90.16-43.11-84.87c-21.63,2.88-32,13.3-36.97,22.21c-2.67,4.8-9.02,5.78-13.02,2.01 c-7.42-7-20.46-13.81-41.94-10.04c-39.5,6.93-58.7,56.07-15.54,93.91C108.83,278.71,136.7,289.91,151.9,294.53z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M363.13,261.03c7.2,2.44,15.05,1.49,21.45-2.61c12.83-8.21,35.66-25.78,55.81-56.74 c30.03-46.14-0.45-86.53-38.72-82.68c-20.82,2.1-31.08,11.77-36.12,20.16c-2.71,4.52-8.83,5.26-12.54,1.53 c-6.9-6.94-19.18-13.87-39.9-10.91c-38.07,5.43-57.98,51.95-17.78,89.55C322.32,244.55,348.7,256.14,363.13,261.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.9948,
    y1: 298.1241,
    x2: 257.7492,
    y2: 268.421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404749"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2663,
    style: {
      stopColor: "#3C4244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5955,
    style: {
      stopColor: "#2F3335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9567,
    style: {
      stopColor: "#1B1B1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181818"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M280.91,285.11c-2.7,11.02-12.13,18.18-21.08,15.99c-8.95-2.19-14.02-12.9-11.32-23.92 c2.7-11.02,12.13-18.18,21.08-15.99C278.54,263.38,283.61,274.09,280.91,285.11z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2226",
    d: "M148.19,267.59c5.48,1.66,11.36,0.76,16.08-2.48c9.46-6.49,26.22-20.26,40.64-44.05 c21.48-35.45-2.42-65.11-31.13-61.29c-15.62,2.08-23.11,9.61-26.7,16.04c-1.93,3.46-6.52,4.17-9.4,1.45 c-5.36-5.05-14.77-9.98-30.29-7.25c-28.52,5-42.39,40.49-11.22,67.82C117.09,256.17,137.22,264.26,148.19,267.59z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M119.98,248.52c3.28,1.07,6.84,0.59,9.72-1.3c5.78-3.79,16.05-11.89,25.02-26.06 c13.38-21.1-0.67-39.27-18.02-37.31c-9.44,1.06-14.04,5.51-16.28,9.34c-1.21,2.06-3.98,2.43-5.68,0.76 c-3.17-3.11-8.78-6.19-18.17-4.74c-17.25,2.67-26.04,23.89-7.58,40.74C101.37,241.26,113.4,246.38,119.98,248.52z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M157.71,239.8c2.43,0.79,5.07,0.44,7.21-0.96c4.29-2.81,11.9-8.82,18.56-19.33 c9.92-15.65-0.5-29.13-13.37-27.68c-7,0.79-10.42,4.09-12.08,6.93c-0.89,1.53-2.95,1.81-4.22,0.56c-2.35-2.31-6.51-4.59-13.48-3.51 c-12.8,1.98-19.31,17.72-5.62,30.22C143.91,234.42,152.84,238.21,157.71,239.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ADFFF",
    d: "M110.3,227.66c1.88,0.61,3.91,0.34,5.57-0.74c3.31-2.17,9.19-6.81,14.33-14.92 c7.66-12.08-0.39-22.48-10.32-21.36c-5.4,0.61-8.04,3.16-9.32,5.35c-0.69,1.18-2.28,1.39-3.25,0.44c-1.81-1.78-5.03-3.54-10.4-2.71 c-9.88,1.53-14.91,13.68-4.34,23.32C99.64,223.51,106.53,226.43,110.3,227.66z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ADFFF",
    d: "M177.97,227.56c1.17,0.38,2.44,0.21,3.48-0.46c2.07-1.36,5.74-4.25,8.95-9.32 c4.78-7.55-0.24-14.04-6.44-13.34c-3.37,0.38-5.02,1.97-5.82,3.34c-0.43,0.74-1.42,0.87-2.03,0.27c-1.13-1.11-3.14-2.21-6.5-1.69 c-6.17,0.96-9.31,8.54-2.71,14.57C171.32,224.97,175.62,226.8,177.97,227.56z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2226",
    d: "M356.79,233.24c5.25,1.85,11.07,1.33,15.92-1.41c9.71-5.5,27.06-17.35,42.81-38.64 c23.46-31.72,2.07-60.6-26.31-58.65c-15.44,1.06-23.29,7.63-27.24,13.41c-2.13,3.11-6.67,3.51-9.31,0.82 c-4.9-4.99-13.79-10.09-29.17-8.42c-28.28,3.06-44.28,35.24-15.62,62.35C327.1,220.9,346.26,229.53,356.79,233.24z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M329.12,214.27c2.99,1.19,6.31,0.93,9.07-0.71c5.55-3.29,15.46-10.42,24.48-23.38 c13.44-19.3,1.31-37.3-14.87-36.38c-8.8,0.5-13.29,4.47-15.55,7.99c-1.22,1.89-3.81,2.1-5.31,0.42c-2.78-3.12-7.84-6.35-16.61-5.47 c-16.12,1.61-25.31,21.27-9.03,38.25C312.22,206.38,323.13,211.88,329.12,214.27z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M363.22,204.87c2.12,0.85,4.48,0.66,6.45-0.5c3.94-2.34,10.98-7.4,17.39-16.61 c9.55-13.71,0.93-26.49-10.56-25.84c-6.25,0.36-9.44,3.18-11.05,5.68c-0.87,1.35-2.7,1.49-3.77,0.29 c-1.98-2.22-5.57-4.51-11.8-3.89c-11.45,1.14-17.98,15.11-6.42,27.17C351.22,199.26,358.97,203.17,363.22,204.87z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ADFFF",
    d: "M323.61,191.53c1.71,0.68,3.61,0.56,5.22-0.34c3.21-1.8,8.97-5.71,14.27-12.87 c7.89-10.68,1.08-20.79-8.22-20.38c-5.06,0.22-7.67,2.41-9,4.35c-0.72,1.05-2.21,1.14-3.05,0.2c-1.57-1.76-4.44-3.59-9.49-3.16 c-9.27,0.79-14.72,11.69-5.53,21.27C313.98,187.02,320.19,190.16,323.61,191.53z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ADFFF",
    d: "M386.08,193.48c0.91,0.29,1.9,0.16,2.7-0.36c1.61-1.04,4.46-3.27,6.96-7.17c3.73-5.8-0.17-10.79-4.99-10.24 c-2.62,0.3-3.9,1.52-4.53,2.57c-0.34,0.57-1.11,0.67-1.58,0.21c-0.88-0.85-2.44-1.7-5.05-1.29c-4.79,0.74-7.24,6.57-2.12,11.19 C380.91,191.49,384.25,192.89,386.08,193.48z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInLove);
export default __webpack_public_path__ + "static/media/in_love.4b202c9426ce9f97599ade23417805fd.svg";
export { ForwardRef as ReactComponent };